/* eslint-disable */
if (themeVars['isHome'] || themeVars['service_areas'] || themeVars['locations']) {

    let geocoder,
        map,
        marker,
        iconBase,
        geoJSONBase,
        lat = 33.3251991,
        lng = -84.6346546,
        mapProp,
        position,
        zipCodeField = $('.service-areas__zipcode'),
        citySelect = $('.counties-list-mobile__select'),
        freeEstimateFormWrapper = $('.estimate-form'),
        selectedCity = $('.counties-list__city-name'),
        icon,
        leftNav,
        styles = [
            { elementType: 'geometry', stylers: [{ color: '#F6F6F4' }] },
            { elementType: 'labels.text.stroke', stylers: [{ color: 'transparent' }] },
            { elementType: 'labels.text.fill', stylers: [{ color: '#7B7B7B' }] },
            {
                featureType: 'administrative.locality',
                elementType: 'labels.text.fill',
                stylers: [{ color: '#7B7B7B' }]
            },
            {
                featureType: 'poi',
                stylers: [
                    { "visibility": "off" }
                ]
            },
            {
                featureType: 'road',
                elementType: 'geometry',
                stylers: [{ color: '#FFFFFF' }]
            },
            {
                featureType: 'road',
                elementType: 'geometry.stroke',
                stylers: [{ color: '#E8EDEB' }]
            },
            {
                featureType: 'road',
                elementType: 'labels.text.fill',
                stylers: [{ color: '#7B7B7B' }]
            },
            {
                featureType: 'road.highway',
                elementType: 'geometry',
                stylers: [{ color: '#FFFFFF' }]
            },
            {
                featureType: 'road.highway',
                elementType: 'geometry.stroke',
                stylers: [{ color: 'transparent' }]
            },
            {
                featureType: 'road.highway',
                elementType: 'labels.text.fill',
                stylers: [{ color: '#7B7B7B' }]
            },
            {
                featureType: 'transit',
                elementType: 'geometry',
                stylers: [{ color: '#EFF0F2' }]
            },
            {
                featureType: 'transit.station',
                elementType: 'labels.text.fill',
                stylers: [{ color: '#7B7B7B' }]
            },
            {
				featureType: "transit.station",
				elementType: "labels",
				stylers: [{visibility: "off"}],
			},
            {
                featureType: 'water',
                elementType: 'geometry',
                stylers: [{ color: '#CAD2D3' }]
            },
            {
                featureType: 'water',
                elementType: 'labels.text.fill',
                stylers: [{ color: '7B7B7B' }]
            },
            {
                featureType: 'water',
                elementType: 'labels.text.stroke',
                stylers: [{ color: 'transparent' }]
            }
        ];

    function CoordMapType(tileSize) {
        this.tileSize = tileSize;
    }

    CoordMapType.prototype.getTile = function (coord, zoom, ownerDocument) {
        var div = ownerDocument.createElement('div');
        div.style.width = this.tileSize.width + 'px';
        div.style.height = this.tileSize.height + 'px';
        div.style.backgroundColor = '#D33333';
        div.style.opacity = 0.2;
        return div;
    };

    citySelect.minimalect();
    function initMap() {
        geocoder = new google.maps.Geocoder();

        mapProp = {
            center: new google.maps.LatLng(lat, lng),
            zoom: 12,
            styles: styles,
			clickableIcons: false,
        };
        position = {
            lat: lat, lng: lng
        }
        iconBase = themeVars['images'];
        geoJSONBase = themeVars['geojson'];
        map = new google.maps.Map(document.querySelector('.service-areas__map'), mapProp);
        if ($(window).width() > 767) {
            icon = {
                url: iconBase + 'point-icon-big.svg',
                scaledSize: new google.maps.Size(80, 80),
            };
        } else if ($(window).width() > 1024) {
            icon = {
                url: iconBase + 'point-icon-big.svg',
                scaledSize: new google.maps.Size(116, 116),
            };
        } else {
            icon = {
                url: iconBase + 'point-icon-big.svg',
                scaledSize: new google.maps.Size(60, 60),
            };
        }
        $(window).on('resize', function () {
            if ($(window).width() > 767) {
                icon = {
                    url: iconBase + 'point-icon-big.svg',
                    scaledSize: new google.maps.Size(80, 80),
                };
            } else if ($(window).width() > 1024) {
                icon = {
                    url: iconBase + 'point-icon-big.svg',
                    scaledSize: new google.maps.Size(116, 116),
                };
            } else {
                icon = {
                    url: iconBase + 'point-icon-big.svg',
                    scaledSize: new google.maps.Size(60, 60),
                }
            }
        });

        function isUSAZipCode(str) {
            return /^\d{5}(-\d{4})?$/.test(str);
        }

        marker = new google.maps.Marker({ position: position, map: map, icon: icon });
        zipCodeField.on('input', function () {
            selectedCity.removeClass('selected');
            if (isUSAZipCode($(this).val())) {

                geocodeAddress(geocoder, map);

            } else {
                $(this).addClass('error');
                $('.service-areas__zipcode-container').addClass('error');
                $('.service-areas__button').addClass('disabled');
            };
        });

        citySelect.on('change', function () {
            let cityName = $(this).val();
            lat = $(this).find('option:selected').data('lat');
            lng = $(this).find('option:selected').data('lng');
            marker.setMap(null);
            map.setCenter({ lat: lat, lng: lng });
            map.overlayMapTypes.setAt(0, null);
            marker = new google.maps.Marker({
                position: {
                    lat: lat, lng: lng
                }, map: map, icon: iconBase + 'point-icon-big.svg'
            });
            map.setZoom(13);
            map.data.forEach(function (feature) {
                map.data.remove(feature);
            });
            map.data.loadGeoJson(geoJSONBase + cityName +
                '.json');
            map.data.setStyle(feature => {
                let strokeColor = '#27B725';
                let fillColor = '#27B725';
                let fillOpacity = '0.1';
                return {
                    fillColor: fillColor,
                    fillOpacity: fillOpacity,
                    strokeColor: strokeColor,
                    strokeWeight: 2
                };
            });
        })
        selectedCity.on('click', function () {
            selectedCity.removeClass('selected');
            $(this).addClass('selected');
            let cityName = $(this).data('name');
            lat = $(this).data('lat');
            lng = $(this).data('lng');
            map.setZoom(13);
            marker.setMap(null);
            map.setCenter({ lat: lat, lng: lng });
            map.overlayMapTypes.setAt(0, null);
            marker = new google.maps.Marker({
                position: {
                    lat: lat, lng: lng
                }, map: map, icon: iconBase + 'point-icon-big.svg'
            });
            map.data.forEach(function (feature) {
                map.data.remove(feature);
            });
            map.data.loadGeoJson(geoJSONBase + cityName +
                '.json');
            map.data.setStyle(feature => {
                let strokeColor = 'transparent';
                let fillColor = '#ED3833';
                let fillOpacity = '0.1';
                return {
                    fillColor: fillColor,
                    strokeColor: strokeColor,
                    fillOpacity: fillOpacity,
                    strokeWeight: 2
                };
            });
        });
    };
    initMap();

    $('#service').minimalect();
    $('.service-areas__button').on('click', function () {
        if ($(this).hasClass('disabled')) {
            return
        }
        $('body').addClass('fix');
        let zipCode = $('.service-areas__zipcode').val();
        let chosenService = $('#service').val();
        freeEstimateFormWrapper.fadeIn();

        if (zipCode != 0) {
            $('#nf-field-61').val(zipCode);

        }
        if (chosenService != ' ') {
            $('#nf-field-57').val(chosenService);
            freeEstimateFormWrapper.find('.minict_wrapper span').removeClass('placeholder');
        }
    });

    function geocodeAddress(geocoder, resultsMap) {
        let zipcode = zipCodeField.val();
        let zipcodeList = themeVars['zipArray'].map(Number);

        geocoder.geocode({ address: zipcode }, function (results, status) {
            if (status == google.maps.GeocoderStatus.OK) {
                if (zipcodeList.indexOf(parseInt(zipcode)) === -1) {
                    $('.service-areas__button').hasClass('disabled') ? '' : $('.service-areas__button').addClass('disabled');
                    zipCodeField.hasClass('error') ? '' : zipCodeField.addClass('error');
                    $('.service-areas__zipcode-container').hasClass('error') ? '' : $('.service-areas__zipcode-container').addClass('error');
                    resultsMap.setCenter(results[0].geometry.location);
                    marker.setMap(null);
                    resultsMap.overlayMapTypes.setAt(0, null);
                    resultsMap.overlayMapTypes.setAt(
                        0, new CoordMapType(new google.maps.Size(256, 256)));
                    if ($(window).width() > 767) {
                        icon = {
                            url: iconBase + 'error-marker.svg',
                            scaledSize: new google.maps.Size(373, 80),
                        };
                    } else if ($(window).width() > 1024) {
                        icon = {
                            url: iconBase + 'error-marker.svg',
                            scaledSize: new google.maps.Size(500, 116),
                        };
                    } else {
                        icon = {
                            url: iconBase + 'error-marker.svg',
                            scaledSize: new google.maps.Size(225, 60),
                        };
                    }
                    $(window).on('resize', function () {
                        if ($(window).width() > 767) {
                            icon = {
                                url: iconBase + 'error-marker.svg',
                                scaledSize: new google.maps.Size(373, 80),
                            };
                        } else if ($(window).width() > 1024) {
                            icon = {
                                url: iconBase + 'error-marker.svg',
                                scaledSize: new google.maps.Size(500, 116),
                            };
                        }
                    })
                    marker = new google.maps.Marker({
                        map: resultsMap,
                        position: results[0].geometry.location,
                        icon: icon
                    });
                } else {
                    $('.service-areas__button').removeClass('disabled');
                    zipCodeField.hasClass('error') ? zipCodeField.removeClass('error') : '';
                    $('.service-areas__zipcode-container').hasClass('error') ? $('.service-areas__zipcode-container').removeClass('error') : '';
                    resultsMap.setCenter(results[0].geometry.location);
                    marker.setMap(null);
                    resultsMap.overlayMapTypes.setAt(0, null);
                    if ($(window).width() > 767) {
                        icon = {
                            url: iconBase + 'point-icon-big.svg',
                            scaledSize: new google.maps.Size(80, 80),
                        };
                    } else if ($(window).width() > 1024) {
                        icon = {
                            url: iconBase + 'point-icon-big.svg',
                            scaledSize: new google.maps.Size(116, 116),
                        };
                    } else {
                        icon = {
                            url: iconBase + 'point-icon-big.svg',
                            scaledSize: new google.maps.Size(60, 60),
                        };
                    }
                    $(window).on('resize', function () {
                        if ($(window).width() > 767) {
                            icon = {
                                url: iconBase + 'point-icon-big.svg',
                                scaledSize: new google.maps.Size(80, 80),
                            };
                        } else if ($(window).width() > 1024) {
                            icon = {
                                url: iconBase + 'point-icon-big.svg',
                                scaledSize: new google.maps.Size(116, 116),
                            };
                        } else {
                            icon = {
                                url: iconBase + 'point-icon-big.svg',
                                scaledSize: new google.maps.Size(60, 60),
                            }
                        }
                    });

                    marker = new google.maps.Marker({
                        map: resultsMap,
                        position: results[0].geometry.location,
                        icon: icon
                    });
                }

            } else {
                $('.service-areas__button').hasClass('disabled') ? '' : $('.service-areas__button').addClass('disabled');
                zipCodeField.hasClass('error') ? '' : zipCodeField.addClass('error');
                $('.service-areas__zipcode-container').hasClass('error') ? '' : $('.service-areas__zipcode-container').addClass('error');
                marker.setMap(null);
                map.setCenter(new google.maps.LatLng(lat, lng));
                map.setZoom(12)
                map.overlayMapTypes.setAt(
                    0, new CoordMapType(new google.maps.Size(256, 256)));

                if ($(window).width() > 767) {
                    icon = {
                        url: iconBase + 'error-marker.svg',
                        scaledSize: new google.maps.Size(373, 80),
                    };
                } else if ($(window).width() > 1024) {
                    icon = {
                        url: iconBase + 'error-marker.svg',
                        scaledSize: new google.maps.Size(500, 116),
                    };
                } else {
                    icon = {
                        url: iconBase + 'error-marker.svg',
                        scaledSize: new google.maps.Size(225, 60),
                    };
                }
                $(window).on('resize', function () {
                    if ($(window).width() > 767) {
                        icon = {
                            url: iconBase + 'error-marker.svg',
                            scaledSize: new google.maps.Size(373, 80),
                        };
                    } else if ($(window).width() > 1024) {
                        icon = {
                            url: iconBase + 'error-marker.svg',
                            scaledSize: new google.maps.Size(500, 116),
                        };
                    }
                })
                marker = new google.maps.Marker({
                    map: resultsMap,
                    position: new google.maps.LatLng(lat, lng),
                    icon: icon
                });

            }
        });
    }

    google.maps.event.addListenerOnce(map, 'tilesloaded', function () {
        setTimeout(() => {
            if ($(window).width() >= 768) {
                leftNav = $('.service-areas__nav').offset().left;
                $('.service-areas__map > div > .gm-style > div:nth-last-of-type(1)').addClass('gmaps-copyright');
                $('.gm-bundled-control').css('left', leftNav - 60 + 'px');
                $('.gm-fullscreen-control').css('left', leftNav - 60 + 'px');
                $('.gmaps-copyright').css('left', leftNav - 10 + 'px');
            }
        }, 1000);
    });
    $(window).on('resize', function () {
        if ($(window).width() >= 768) {
            leftNav = $('.service-areas__nav').offset().left;
            $('.service-areas__map > div > .gm-style > div:nth-last-of-type(1)').addClass('gmaps-copyright');

            $('.gm-bundled-control').css('left', leftNav - 60 + 'px');
            $('.gm-fullscreen-control').css('left', leftNav - 60 + 'px');
            $('.gmaps-copyright').css('left', leftNav - 10 + 'px');
        } else {
            $('.service-areas__map > div > .gm-style > div:nth-last-of-type(1)').removeClass('gmaps-copyright');

            $('.gm-bundled-control').css('left', 'auto');
            $('.gm-fullscreen-control').css('left', 'auto');
            $('.gmaps-copyright').css('left', 'auto');
        }
    });
}
$(document).on('click', '.placeholder', function () {
    if ($(this).next('ul:visible')) {
        $('.minict_wrapper').removeClass('active');
    }
});



// WEBPACK FOOTER //
// ./scripts/modules/service-areas.js